<template>
  <div class="state_card">
    <div class="content">
      <h5>{{ name }}</h5>
      <p>
        <span class="value">{{ value }}</span> {{ text }}
      </p>
    </div>

    <div class="icon" v-if="icon">
      <button type="button" @click="actions">
        <v-icon>{{ icon }}</v-icon>
      </button>
    </div>
    <div class="icon_logo">
      <img src="@/assets/media/images/Icons/logo.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "value", "text", "icon"],
  methods: {
    actions() {
      this.$emit("action");
    },
  },
};
</script>

<style lang="scss">
.state_card {
  background: white;
  border-radius: 15px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: start;
  flex-direction: column;
  box-shadow: 0 0 10px #ebebeb;
  position: relative;
  min-height: 111px;
  overflow: hidden;

  // &::after {
  //   position: absolute;
  //   content: "";
  //   width: 112px;
  //   height: 50px;
  //   background-size: 100px;
  //   left: 5px;
  //   top: 11px;
  // }
  .content {
    display: flex;
    flex-direction: column;
    // min-height: 70px;
    position: relative;
    z-index: 10;
  }
  h5 {
    font-size: 1.25rem !important;
    font-weight: 500;
    text-align: start;
    letter-spacing: 0.0125em !important;
    text-transform: capitalize;
    color: #339989;
    margin-bottom: 15px;
    position: relative;
  }
  p {
    // margin: auto 0 0;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    text-align: start;
    line-height: 20px;
    letter-spacing: 1px;
    text-transform: capitalize;
    margin: 0;

    color: #ffffff;
    span.value {
      // font-style: normal;
      // font-weight: 700;
      // font-size: 25px;
      // line-height: 30px;
      color: black;

      margin: 0;
      font-size: 18px;
      word-break: break-word;
    }
  }
  .icon {
    position: absolute;
    top: 8px;
    right: 8px;
    button {
      //   background: #ffffff;
      //   border: 2.5px solid #2e5599;
      //   width: 30px;
      //   height: 30px;
      //   border-radius: 50%;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   box-shadow: none !important;
      .v-icon {
        color: #339989 !important;
        //     font-size: 16px !important;
      }
    }
  }
  .icon_logo {
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 30px;
    height: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

@keyframes buncing {
  0% {
    transform: translateY(0) scale(0.8);
  }
  50% {
    transform: translateY(-10px) scale(1);
  }
  100% {
    transform: translateY(0) scale(0.8);
  }
}

body[dir="rtl"] {
  .state_card {
    .icon {
      position: absolute;
      top: 8px;
      right: unset;
      left: 8px;
    }
    .icon_logo {
      position: absolute;
      bottom: 8px;
      right: unset;
      left: 8px;
    }
  }
}
</style>
